import { ActionBar, ArchivesIcon } from '@dreryk/react-components';

import { medicalDocumentationCreateTranslationKeys } from '../../../translations';
import { MedicalDocumentationCreateModalOpener } from '../MedicalDocumentationCreateModal.opener';

type MedicalDocumentationCreateActionProps = {
   readonly patientId: number;
};

export const MedicalDocumentationCreateAction = (props: MedicalDocumentationCreateActionProps): JSX.Element => {
   return (
      <MedicalDocumentationCreateModalOpener patientId={props.patientId}>
         {({ openModal }) => (
            <ActionBar.SupplementaryLink
               testId={'medicalDocumentationCreate'}
               icon={<ArchivesIcon />}
               label={medicalDocumentationCreateTranslationKeys.createPatientRecords}
               onClick={openModal}
            />
         )}
      </MedicalDocumentationCreateModalOpener>
   );
};
